module.exports = __webpack_public_path__ + "static/media/proces_01.a95e24ea.svg";